/*@ngInject*/
const PolicyActionsMediator = function (policyActionRepository, endorsementActionRepository, policyRewriteActionRepository) {

    this.startPolicyCancellation = function (policyId) {
        return policyActionRepository.startPolicyCancellation(policyId);
    };

    this.reinstatePolicy = function (policyCancellationId, reason, detail) {
        return policyActionRepository.reinstatePolicy(policyCancellationId, reason, detail);
    };

    this.startEndorsement = function (policyId) {
        return endorsementActionRepository.start(policyId);
    };

    this.startPolicyRewrite = function (policyId, isReissue) {
        return policyRewriteActionRepository.start(policyId, isReissue);
    };

};

angular.module('gw-um-submission')
    .service('policyActionsMediator', PolicyActionsMediator);
